// API Configuration

export const API_URL = import.meta.env.VITE_API_URL || 'https://api.site-plans.kencove.com';
export const TILES_URL = import.meta.env.VITE_TILES_URL || 'https://tiles.site-plans.kencove.com';

// Smplrspace SDK Configuration (public tokens - safe for client-side)
export const SMPLRSPACE_ORG_ID = import.meta.env.VITE_SMPLRSPACE_ORG_ID || '2fb39b12-b472-4dd7-abb0-1c5cdc9384d4';
export const SMPLRSPACE_TOKEN = import.meta.env.VITE_SMPLRSPACE_TOKEN || 'pub_eadc4403b86b4aeca02c0ac3c1917f75';

export const endpoints = {
  // Sites & Buildings
  sites: `${API_URL}/api/v1/sites`,
  buildings: (siteId: string) => `${API_URL}/api/v1/sites/${siteId}/buildings`,
  footprints: (siteId: string) => `${API_URL}/api/v1/sites/${siteId}/footprints`,
  zoneBoundaries: (siteId: string) => `${API_URL}/api/v1/sites/${siteId}/zones/boundaries`,
  buildingModel: (buildingId: string) => `${API_URL}/api/v1/buildings/${buildingId}/model`,
  buildingCapacity: (buildingId: string) => `${API_URL}/api/v1/buildings/${buildingId}/capacity`,
  zones: (buildingId: string) => `${API_URL}/api/v1/buildings/${buildingId}/zones`,

  // Spatial & AI
  spatialQuery: `${API_URL}/api/v1/spatial/nearby`,
  aiQuery: `${API_URL}/api/v1/ai/query`,

  // File Upload & Processing
  upload: `${API_URL}/api/v1/upload`,
  process: `${API_URL}/api/v1/process`,
  fileStatus: (fileId: string) => `${API_URL}/api/v1/files/${fileId}/status`,

  // CAD Preview
  preview: `${API_URL}/api/v1/preview`,
  previewById: (previewId: string) => `${API_URL}/api/v1/preview/${previewId}`,
  previewConfirm: (previewId: string) => `${API_URL}/api/v1/preview/${previewId}/confirm`,

  // Rack Rows
  rackRows: (zoneId: string) => `${API_URL}/api/v1/zones/${zoneId}/rack-rows`,
  rackRowById: (rackRowId: string) => `${API_URL}/api/v1/rack-rows/${rackRowId}`,
  generateLocations: (rackRowId: string) => `${API_URL}/api/v1/rack-rows/${rackRowId}/generate-locations`,
  exportLocations: (zoneId: string, format: string = 'csv') =>
    `${API_URL}/api/v1/zones/${zoneId}/locations/export?format=${format}`,
  zoneLocations: (zoneId: string) => `${API_URL}/api/v1/zones/${zoneId}/locations`,

  // Odoo / Simulation
  odooHealth: (env: string = 'review') => `${API_URL}/api/v1/odoo/health?env=${env}`,
  odooWarehouses: `${API_URL}/api/v1/odoo/warehouses`,
  odooLocations: (warehouse: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/locations?warehouse=${warehouse}&env=${env}`,
  odooQuants: (warehouse: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/quants?warehouse=${warehouse}&env=${env}`,
  odooMoves: (warehouse: string, start: string, end: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/moves?warehouse=${warehouse}&start_date=${start}&end_date=${end}&env=${env}`,
  odooPlannedPicks: (warehouse: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/picks/planned?warehouse=${warehouse}&env=${env}`,

  // Simulation-friendly aliases
  simulationMoves: (warehouse: string, start: string, end: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/simulation/moves?warehouse=${warehouse}&start=${start}&end=${end}&env=${env}`,
  simulationQuants: (warehouse: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/simulation/quants?warehouse=${warehouse}&env=${env}`,
  simulationPicks: (warehouse: string, env: string = 'review') =>
    `${API_URL}/api/v1/odoo/simulation/picks?warehouse=${warehouse}&env=${env}`,
};
